import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MR',
  text: 'Armé la primera mesa rebatible en un fin de semana siguiendo el Tomo 2. El cliente me pagó $480.000 ARS. El combo se pagó 24 veces solo.',
  author: 'Marcelo R.',
  location: 'Buenos Aires',
  role: 'Carpintero Emprendedor'
}, {
  initials: 'JC',
  text: 'Los planos de la Cama Murphy son los más claros que vi en mi vida. Primer intento, todo cuadró. El cliente me mandó 3 referidos más.',
  author: 'Jorge C.',
  location: 'Rosario',
  role: 'Taller Propio'
}, {
  initials: 'SV',
  text: 'Antes tardaba 3 días en calcular un presupuesto. Con la Calculadora del Bono 1 lo hago en 3 minutos y cobro lo que corresponde.',
  author: 'Sofía V.',
  location: 'Córdoba',
  role: 'Carpintera Independiente'
}];
export function Testimonials() {
  return <section className="py-16 bg-cream-dark" data-id="element-331">
      <div className="container mx-auto px-4" data-id="element-332">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-333">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-warm border border-wood-light/10 relative" data-id="element-334">
              <div className="absolute -top-5 left-8 bg-wood-dark text-amber w-12 h-12 rounded-full flex items-center justify-center font-serif font-bold text-xl border-4 border-white" data-id="element-335">
                {testimonial.initials}
              </div>
              <div className="flex mb-4 mt-2" data-id="element-336">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-amber fill-amber" data-id="element-337" />)}
              </div>
              <p className="text-charcoal/80 italic mb-6 leading-relaxed" data-id="element-338">
                "{testimonial.text}"
              </p>
              <div className="mt-auto" data-id="element-339">
                <p className="font-bold text-wood-dark" data-id="element-340">{testimonial.author}</p>
                <p className="text-sm text-charcoal/60" data-id="element-341">
                  {testimonial.location} | {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}